<template>
  <v-dialog v-model="dialog" persistent max-width="1000px">
    <v-card :loading="loading">
      <v-card-title>
        <span class="text-h5">Prezzi prodotto</span>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row dense>          
            <v-col cols="5" class="mt-5">
              <h3 class="pl-3">LISTINI</h3>
              <v-data-table :headers="headersPrezzi" :items="prezzi" dense hide-default-footer disable-sort>
                <template v-slot:[`header.prezzo`]="{ header }">
                  <v-badge dot title="Il valore è modificabile" class="mt-3">{{header.text}}</v-badge>
                  <div class="text-caption">listino</div>
                </template>
                <template v-slot:[`header.sconto`]="{ header }">
                  <v-badge dot title="Sconto su listino fornitore. Il valore è modificabile" class="mt-3">{{header.text}}</v-badge>
                  <div class="text-caption">fornitore</div>
                </template>                
                <template v-slot:[`header.ricarico`]="{ header }">
                  <v-badge dot title="Ricarico su prezzo di acquisto. Il valore è modificabile" class="mt-3">{{header.text}}</v-badge>
                  <div class="text-caption">acquisto</div>
                </template>
                <template v-slot:[`item.prezzo`]="{ item }">
                  <v-edit-dialog :return-value.sync="item.prezzo" large persistent cancel-text="Annulla" save-text="Salva" @save="onSavePrezzo(item)">
                    <div>{{ item.prezzo | euro}}</div>
                    <template v-slot:input>
                      <div class="mt-4 text-h6">Prezzo listino</div>
                      <v-text-field v-model="item.prezzo" label="Valore" single-line autofocus :rules="[numerico]"></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>
                <template v-slot:[`item.sconto`]="{ item }">
                  <v-edit-dialog :return-value.sync="item.sconto" large persistent cancel-text="Annulla" save-text="Salva" @save="onSaveSconto(item)">
                    <div>{{ item.sconto | euro}}</div>
                    <template v-slot:input>
                      <div class="mt-4 text-h6">Sconto su fornitore</div>
                      <v-text-field v-model="item.sconto" label="Valore" single-line autofocus :rules="[numerico]"></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>                
                <template v-slot:[`item.ricarico`]="{ item }">
                  <v-edit-dialog :return-value.sync="item.ricarico" large persistent cancel-text="Annulla" save-text="Salva" @save="onSaveRicarico(item)">
                    <div>{{ item.ricarico | percento}}</div>
                    <template v-slot:input>
                      <div class="mt-4 text-h6">Ricarico</div>
                      <v-text-field v-model="item.ricarico" label="Valore" single-line autofocus :rules="[numerico]"></v-text-field>
                    </template>
                  </v-edit-dialog>
                </template>
              </v-data-table>
              <h5 class="mt-3">* = Listino ivato</h5>
            </v-col>
            <v-spacer></v-spacer> 
            <v-col cols="7" class="mt-5">
              <h3 class="pl-3">ACQUISTI</h3>
              <v-simple-table dense class="mt-1">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">FORNITORE</th>
                      <th class="text-right">QUANTITA'</th>
                      <th class="text-right">PREZZO</th>
                      <th class="text-right">ULTIMO ACQUISTO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in fornitori" :key="item._id">
                      <td class="text-left">{{ item.fornitore.descrizione }}</td>
                      <td class="text-right">{{ item.quantita }}</td>
                      <td class="text-right">{{ item.prezzo | euro }}</td>
                      <td class="text-right">{{ item.data | date }}</td>
                    </tr>
                  </tbody>             
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.stop="dialog = false">OK</v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn  color="blue" text v-bind="attrs" @click="snackbar = false">
          OK
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>  
</template>

<script>
  import _ from 'lodash'
  import configurazioni from '@/services/configurazioniService'
  import movimenti from '@/services/movimentiService'
  import prodotti from '@/services/prodottiService'
  export default {
    props: {
      prodotto: Object,
      item: Object,
      show: Boolean
    },
    data () {
      return {
        fornitori: [],
        prezzi: [],
        vendite: [],
        listini: [],
        listinoAcquisto: null,
        attuale: [],
        dialog: false,
        loading: false,
        headersPrezzi: [
          { text: 'LISTINO', value: 'listino', align: 'start' },
          { text: 'PREZZO', value: 'prezzo', align: 'end' },
          /* { text: 'SCONTO', value: 'sconto', align: 'end' }, */  // TODO: Completare la gestione
          { text: 'RICARICO', value: 'ricarico', align: 'end' }
        ],
        numerico: value => !isNaN(value) || 'Il valore deve essere numerico',
        snackbar: false,
        snackColor: '',
        snackText: '',
        timeout: 4000
      }
    },
    async mounted() {
      const conf = await configurazioni.getConfigurazione('listini')
      this.listini = conf.listini
      this.listinoAcquisto = conf.acquisto || { ivato: false }      
    },
    watch: {
      async show(value) {
        if (value) {
          this.dialog = true
          await this.elaboraTabelle()
        }
      }
    },
    methods: {
      async onSaveAcquisto(item) {
        const valore = isNaN(item.acquisto) ? '' : +parseFloat(item.acquisto).toFixed(2)
        await this.aggiornaPrezzo(item, valore, 'acquisto')
      },
      async onSavePrezzo(item) {
        const valore = isNaN(item.prezzo) ? '' : +parseFloat(item.prezzo).toFixed(2)
        await this.aggiornaPrezzo(item, valore)
      },
      async onSaveRicarico(item) {
        let valore = ''
        if (!isNaN(item.ricarico)) {
          const ricarico = +parseFloat((item.ricarico) / 100).toFixed(2)
          valore = item.acquisto * (ricarico + 1)
        }
        await this.aggiornaPrezzo(item, valore)
      },
      async onSaveSconto(item) {
        // TODO: Completare
        const valore = isNaN(item.sconto) ? '' : +parseFloat(item.sconto).toFixed(2)
        // await this.aggiornaPrezzo(item, valore)
      },
      async aggiornaPrezzo(item, valore, tipoPrezzo = 'listino') {
        prodotti.clearCache()
        const idProdotto = this.prodotto.codice
        if (!idProdotto || ! valore) {
          this.snackColor = 'red accent-2'
          this.snackText = 'Il valore non è valido'
          this.snackbar = true
          return
        }
        // considero sempre codiceListino perchè la chiave è completa anche se cliente (es _L_codicexxx, _LT_tipoyyyy) o tipoCliente
        await prodotti.aggiornaPrezzo(tipoPrezzo, idProdotto, item.codiceListino, valore)
        await this.elaboraPrezzi()
        this.$emit('aggiornaPrezzo', { listino: item.codiceListino, valore, codice: idProdotto, riga: this.prodotto, item: this.item })
        this.snackColor = 'success'
        this.snackText = 'Il prezzo di listino è stato aggiornato'
        this.snackbar = true
      },
      async elaboraTabelle() {
        this.loading = true
        await this.elaboraFornitori()
        await this.elaboraPrezzi()
        this.loading = false
      },
      async elaboraFornitori() {
        if (!this.prodotto) return
        const r = this.prodotto
        const mm = await movimenti.getMovimentiProdottoTipoCliente(r.codice, null, 'acquisto')
        const fornitori = []
        for (let m of _.sortBy(mm.rows, 'data').reverse()) {
          const riga = {
            fornitore: m.anagrafica.fornitore,
            quantita: m.quantita,
            prezzo: +(m.valore / m.quantita).toFixed(2),
            data: m.data
          }
          fornitori.push(riga)
        }
        this.fornitori = fornitori
      },
      async elaboraPrezzi() {
        if (!this.prodotto) return
        var r = this.prodotto
        const listini = this.listini
        const prodotto = await prodotti.getProdotto(r.codice)
        const acquisto = _.get(prodotto, 'magazzino.prezzoAcquisto', 0)
        const pp = prodotto.prezzo
        const prezzi = []

        for (let listino of listini) { // elenco listini
          let pz = pp[listino.codice]
          if (pz) {
            const base = pz.base ? +parseFloat(pz.base).toFixed(2) : 0
            let ricarico = acquisto > 0 && pz.base ? +(((base - acquisto) / acquisto) * 100).toFixed(2) : '---'
            const iva = _.get(r, 'aliquotaIva.valore', 22)
            // Dovrei mostrare entrambi i prezzi, ma diventa un problema per quale è modificabile, perchè cambia in base al listino
            let netto = listino.ivato ? base / (1 + iva / 100) : base
            let lordo = listino.ivato ? base : base * (1 + iva / 100)
            if (listino.ivato && !this.listinoAcquisto.ivato) {
              // const iva = _.get(r, 'aliquotaIva.valore', 22)
              let prz = base / (1 + iva / 100)
              ricarico = acquisto > 0 && pz.base ? +(((prz - acquisto) / acquisto) * 100).toFixed(2) : '---'
            }
            const ivato = listino.ivato ? '* ' : ''
            const prezzo = {
              codiceListino: listino.codice,
              listino: ivato + (listino.descrizione || listino.codice),
/*               prezzoNetto: +netto.toFixed(2),
              prezzo: +lordo.toFixed(2), */
              prezzo: pz.base ? base : '',
              ricarico: ricarico,
              acquisto
            }
            prezzi.push(prezzo)
          } else {
            const prezzo = {
              codiceListino: listino.codice,
              listino: listino.descrizione || listino.codice,
              // prezzoNetto: '',              
              prezzo: '',
              ricarico: '',
              acquisto
            }
            prezzi.push(prezzo)
          }
        }

        const elencoPrezzi = Object.keys(pp)
        for (let p of elencoPrezzi.filter(x => !listini.map(l => l.codice).includes(x))) {  // elenco prezzi speciali (no listini)
          let pz = pp[p]
          if (pz) {
            const listino = this.listini.find(x => x.codice === p)
            const ricarico = acquisto > 0 ? +(((pz.base - acquisto) / acquisto) * 100).toFixed(2) : '---'
            const prezzo = {
              codiceListino: p,
              listino: listino ? listino.descrizione : p,
              prezzo: +pz.base.toFixed(2),
              ricarico: ricarico,
              acquisto
            }
            prezzi.push(prezzo)
          }
        }
        // elenco prezzi specifici per il cliente selezionato (deve verificare di non averli già riportati sopra)
/*         const listinoCliente = `_L_${this.cliente.codice}`
        if (!elencoPrezzi.find(x => x === listinoCliente)) {
            const prezzo = {
              codiceListino: listinoCliente,
              listino: listinoCliente,
              prezzo: '',
              ricarico: '',
              acquisto
            }
            prezzi.push(prezzo)
        } */
/*         const tipologiaCliente = _.get(this.cliente, 'amministrativi.tipologiaCliente.codice','')
        if (tipologiaCliente.length > 0) {
          const listinoTipologia = `_LT_${tipologiaCliente}`
          if (!elencoPrezzi.find(x => x === listinoTipologia)) {
              const prezzo = {
                codiceListino: listinoTipologia,
                listino: listinoTipologia,
                prezzo: '',
                ricarico: '',
                acquisto
              }
              prezzi.push(prezzo)
          }
        } */
        this.prezzi = prezzi
      }   
    }
  }
</script>
